export default __webpack_public_path__ + "static/main-img03-ecc1b9584a32b77abbacc0a7b5188443.jpg";